export default __webpack_public_path__ + "557ef31a2557f6f6605673b5a357ded5.png";